import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../api/axios';

export function useLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await apiClient.post('/logout');
    },
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ['user'] });
    },
  });
} 